// Invite-sharing helpers — extracted from PeopleSheet so the wording and
// clipboard behavior are unit-testable.
//
// Two rules live here:
//  1. Type-aware language: a household invite must NEVER say "trip"
//     (and vice versa). The group's `kind` decides the noun and the pitch.
//  2. Belt-and-suspenders sharing: opening Messages/WhatsApp also copies the
//     link to the clipboard first. If the share sheet opens on the wrong
//     conversation or the user backs out, the link is still in their pocket.

export function groupNoun(group) {
  return group?.kind === 'household' ? 'household' : 'trip'
}

export function buildInviteMessage(group, inviteUrl) {
  const noun = groupNoun(group)
  // The pitch adapts: statements are the trip workflow's hook; a household
  // is an ongoing ledger, so the hook is tracking shared expenses.
  const pitch = noun === 'household'
    ? 'so we can track and split our shared expenses'
    : 'add your card statement so we can split expenses fairly'
  return `Join our ${noun} "${group?.name}" on AutoSplit — ${pitch}: ${inviteUrl}`
}

// Copy the invite link, then open the share target. Returns true if the
// clipboard write was attempted (caller uses this to show "Link copied").
export function copyThenOpen(inviteUrl, shareHref, openFn = (href) => window.open(href, '_blank')) {
  if (!inviteUrl) return false
  navigator.clipboard?.writeText(inviteUrl)
  openFn(shareHref)
  return true
}
